import { render, staticRenderFns } from "./BlogPostsTheme.vue?vue&type=template&id=0a94a3f4&scoped=true&"
import script from "./BlogPostsTheme.vue?vue&type=script&lang=ts&"
export * from "./BlogPostsTheme.vue?vue&type=script&lang=ts&"
import style0 from "./BlogPostsTheme.vue?vue&type=style&index=0&id=0a94a3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a94a3f4",
  null
  
)

export default component.exports